module.exports = __webpack_public_path__ + "static/media/thumbnail_advincula-soft-cup.fb5ca0ae.jpg";